// test955
(955 && 0);
